
import { Theme } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import EkonomiskAnalysLogo from '../../../EkonomiskAnalys/Components/EkonomiskAnalysLogo/EkonomiskAnalysLogo';
import EDTypography from '../../../../../../../BaseComponents/Typography/EDTypography';
import { EDTextEdit } from '../../../../../../../BaseComponents/TextEdit/EDTextEdit';
import { OnClickStartAnalysFnType } from '../AnalysUtdelningMain/AnalysUtdelningMain';
import EkonomiskAnalysInitQuery from '../../../EkonomiskAnalys/Queries/EkonomiskAnalysInitQuery/EkonomiskAnalysInitQuery';
import EDAvenyProgress from '../../../../../../../BaseComponents/ProgressIndicators/AvenyProgress/EDAvenyProgress';

interface IProps {
  startAnalysName: string;
  onClickStartAnalys: OnClickStartAnalysFnType;
  searchText: string;
  onSearchTextChanged: (text: string) => void;
  isGasKodplan: boolean;
  activeCodeplanID: string;
}

const useStyles = makeStyles()((theme: Theme) => ({
  container: {
    width: '100%',
    padding: theme.spacing(2),
    boxSizing: 'border-box',
  },
  flexContainer: {
    width: '100%',
    display: 'flex',
    flex: '0 1 auto',
    justifyContent: 'space-between',
  },
  titleContainer: {
    flex: '2 1 50%',
    textAlign: 'center',
  },
  side: {
    flex: '0 1 25%',
  },
  textContainer: {
    paddingTop: theme.spacing(1),
    display: 'inline-flex',
    cursor: 'pointer',
  },
  searchText: {
    minWidth: '300px',
    '& label': {
      backgroundColor: 'white',
    },
  },
  subContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
  },
}));

/**
 * Överliggande information och interaction till huvudtabellen för AnalysUtdelningsrutinen
 */
const AnalysUtdelningHeader: React.FunctionComponent<
  React.PropsWithChildren<IProps>
> = props => {
  const { classes } = useStyles();

  const filterEditPlaceholder = `Filtrera på Namn, Typ${
    props.isGasKodplan ? ', Roll' : ''
  } eller Kategori`;

  return (
    <div className={classes.container}>
      <div className={classes.flexContainer}>
        <div className={classes.side}>
          <EkonomiskAnalysInitQuery codeSystemId={props.activeCodeplanID}>
            {({ ekLogo, listQueryLoading }) =>
              !listQueryLoading && ekLogo ? (
                <EkonomiskAnalysLogo logo={ekLogo} />
              ) : (
                <EDAvenyProgress />
              )
            }
          </EkonomiskAnalysInitQuery>
        </div>
        <EDTypography variant="h5" className={classes.titleContainer}>
          Utdelning av ekonomisk analys
        </EDTypography>
        <div className={classes.side} />
      </div>
      <div className={classes.subContainer}>
        <div
          className={classes.textContainer}
          onClick={props.onClickStartAnalys}
        >
          <EDTypography bold>Startanalys:</EDTypography>
          &nbsp;
          <EDTypography>{props.startAnalysName}</EDTypography>
        </div>
        <EDTextEdit
          placeholder={filterEditPlaceholder}
          fullWidth={false}
          label="Snabbfiltrera listan"
          onChange={props.onSearchTextChanged}
          value={props.searchText}
        />
      </div>
    </div>
  );
};

export default AnalysUtdelningHeader;
